import { HorizontalRadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";
import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";

import type { GroupType } from "./types";
import { createRadioOptions } from "./utils";

type Props = {
    value: InclusionOption;
    groupType?: GroupType;
    onChange: (value: InclusionOption) => void;
};

const InclusionGroup = ({ value, groupType = "binary", onChange }: Props) => {
    const options = createRadioOptions(groupType);

    return (
        <HorizontalRadioSelect
            size="sm"
            items={options}
            selected={value}
            onSelect={onChange}
        />
    );
};

export default InclusionGroup;
